import React from 'react';
import styled from 'styled-components';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'i18n';
import CloseButton from 'components/buttons/closeButton/CloseButtonComponent';
import LegDetails from './components/legDetails/LegDetailsComponent';
import FlightSelection from './components/flightSelection/FlightSelectionComponent';
import flexbox from 'styles/utils/flexbox';
import { mediaQueries } from 'styles/utils/mediaQueries';

function FlightDetailsModalComponent({
  modalOpen,
  checked,
  price,
  flightsCombination,
  flightDetails,
  onAfterOpen,
  onAfterClose,
  onClickClose,
  onChangeSelected,
  onClickSelect,
  airlineWhitelabel,
}) {
  const displayReferences =
    flightsCombination &&
    flightsCombination
      .map((leg) => {
        return leg.arrivalAndDepartureAirportAreNotTheSame || leg.initialAndLastAirportAreNotTheSame;
      })
      .reduce((acc, curr) => acc || curr, false);

  return (
    <Modal
      isOpen={modalOpen}
      onAfterOpen={onAfterOpen}
      onAfterClose={onAfterClose}
      onRequestClose={onClickClose}
      closeTimeoutMS={300}
      className='custom-modal-content'
      overlayClassName='custom-modal'
    >
      <Root>
        <Header>
          <Title>
            <FormattedMessage
              id={'flightDetails.label'}
              description={'Flight details'}
              defaultMessage={'Flight details'}
            />
          </Title>
          <CloseButton onClick={onClickClose} />
        </Header>
        <Content>
          {flightsCombination &&
            flightsCombination.map((leg, index) => (
              <LegDetails
                key={`leg-${index}`}
                {...leg}
                index={index}
                flightDetails={flightDetails}
                airlineWhitelabel={airlineWhitelabel}
              />
            ))}
        </Content>
        {displayReferences && (
          <ReferencesWrap>
            <Reference>
              <Warning icon='info-circle' />
              <ReferenceMessage>
                <FormattedMessage
                  id='airportsAreNotTheSameReference'
                  description='Airports are not the same.'
                  defaultMessage='Airports are not the same.'
                />
              </ReferenceMessage>
            </Reference>
          </ReferencesWrap>
        )}
        <FlightSelection
          price={price}
          checked={checked}
          onChange={onChangeSelected}
          onClick={onClickSelect}
          airlineWhitelabel={airlineWhitelabel}
        />
      </Root>
    </Modal>
  );
}

export default FlightDetailsModalComponent;

const Root = styled.div`
  user-select: none;
`;

const Header = styled.div`
  ${flexbox({
    justifyContent: 'space-between',
    alignItems: 'center',
  })}
  height: 61px;
  padding: 0 20px;
  background: ${({ theme }) => theme.colors.background.greyLight};

  ${mediaQueries.fromAndAbove.desktop`
    padding: 0 20px 0 40px;
  `}
`;

const Title = styled.div`
  font-family: ${({ theme }) => theme.fonts.displaySubtle};
  font-size: 2em;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.default};
`;

const Content = styled.div`
  ${flexbox({
    flexWrap: 'wrap',
    justifyContent: 'center',
  })}
  background: ${({ theme }) => theme.colors.background.light};

  ${mediaQueries.fromAndAbove.desktop`
    ${flexbox()}
  `}
`;

const ReferencesWrap = styled.div`
  padding: 20px 40px;
  background: ${({ theme }) => theme.colors.background.light};
`;

const Reference = styled.div`
  display: flex;
  align-items: center;
`;

const ReferenceMessage = styled.div`
  margin-left: 8px;
  font-size: 1.4em;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

const Warning = styled(FontAwesomeIcon)`
  margin: 0px 6px;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.severity.error[0]};
`;
